import React, { useContext } from 'react';
import { RicosContext, usePluginExportsContext } from 'ricos-context';
import type { Node } from 'ricos-schema';
import { Node_Type } from 'ricos-schema';
import type { ImageNode } from 'ricos-schema/next';
import type { PluginProps } from 'ricos-types';
import { Loader, MediaItemErrorMsg } from 'wix-rich-content-ui-components';

import { getImageClickActionConfig } from '../viewer/get-image-click-action-config';
import { Image } from '../viewer/image';
import styles from './component.scss';
import { EditorImageCaption } from './editor-image-caption';

export const EditorImage: React.FC<PluginProps> = ({ updateAttributes, node }) => {
  const { t, isMobile } = useContext(RicosContext);
  const { loading, loadingPercentage, error, tempData } = node.attrs;
  const pluginExports = usePluginExportsContext();

  const onCaptionChange = (caption: string) => {
    updateAttributes({ caption });
  };

  const { src } = node.attrs.image || {};
  const shouldRender = !!tempData || src?.url || src?.id;

  const ricosNode: Node = {
    imageData: node.attrs,
    id: node.attrs.id,
    type: Node_Type.IMAGE,
    nodes: [],
  };

  const imageClickActionConfig = getImageClickActionConfig({
    imageData: ricosNode.imageData,
  });

  const AiCaptionTrigger = pluginExports.aiIntegrations?.image?.captionTrigger
    ? pluginExports?.aiIntegrations?.image?.captionTrigger
    : null;

  const caption = (
    <EditorImageCaption
      onCaptionChange={onCaptionChange}
      imageType={imageClickActionConfig.type}
      caption={ricosNode.imageData?.caption ?? ''}
    />
  );

  return shouldRender ? (
    <>
      <Image
        isMobile={isMobile}
        node={ricosNode}
        dataUrl={tempData}
        imageClickActionConfig={{ type: 'regular' }}
        shouldLazyLoadImages={false}
        captionComponent={
          AiCaptionTrigger ? (
            // This is temporary solution until we make caption rich
            <div className={styles.captionWrapper}>
              <AiCaptionTrigger
                node={ricosNode as unknown as ImageNode}
                onCaptionChange={onCaptionChange}
              />
              {caption}
            </div>
          ) : (
            caption
          )
        }
      />
      {loading && <Loader type={'medium'} percent={loadingPercentage} />}
      {error && <MediaItemErrorMsg error={error} t={t} />}
    </>
  ) : null;
};
